<template>
  <div class="pop" :style="getstyle">
    <pophead :titledata="titledata"></pophead>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import pophead from "./pophead.vue";
import popcontent from "./popcontent.vue";
// import cfg from "./config.js";
export default {
  components: { pophead, popcontent },
  props: ["titledata", "styledata"], //电池插箱id
  computed: {
    getstyle() {
      if (typeof this.styledata.l == "string") {
        let h = window.screen.availHeight;
        let w = window.screen.availWidth;
        let res = `left:${this.styledata.l};top:${this.styledata.t};width:${this.styledata.w}rem;`;
        // transform: translateX() translateY();
        let transform = "transform:";

        if (parseInt(this.styledata.l) * 2 > w) {
          transform += "translateX(-100%) ";
        } else {
          transform += "translateX(0) ";
        }
        if (parseInt(this.styledata.t) * 2 > h) {
          transform += "translateY(-100%);";
        } else {
          transform += "translateY(0);";
        }
        return res + transform;
      } else {
        let l='',t='',w=''
        if (this.isTrue(this.styledata.l)) {
          l = `position: absolute;left:${this.styledata.l}rem;`
        }
        if (this.isTrue(this.styledata.t)) {
          t = `top:${this.styledata.t}rem;`
        }
        return l+t+`width:${this.styledata.w}rem;`;
      }
      // return `left:1rem;`
      // return `left:${this.styledata.l}rem;top:${this.styledata.t}rem;width:${this.styledata.w}rem;height:${this.styledata.h}rem;`
    },
  },
  methods: {
    isTrue(item) {
      return item || item == 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.pop {
  z-index: 999;
  
  // box-shadow: 0 0 15px #888888;
}
.content {
  position: relative;
  margin-top: 0.01rem;
  // background: rgba(255, 255, 255, 0.8);
  background: linear-gradient(
    top,
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 0.8)
  );
  // top: .22rem;
  width: 100%;
  min-height: 0.2rem;
  height: auto;
  border-bottom: 3px solid #151a86;
  // border-image: linear-gradient(
  //     top,
  //     rgba(0, 0, 255, 0),
  //     rgba(77, 170, 170, 0.8)
  //   )
  //   1 1;
  padding: 0 0.05rem;
}
// .content::after {
//   content: " ";
//   display: block;
//   position: absolute;
//   left: -2px;
//   right: -2px;
//   top: -2px;
//   bottom: -2px;
//   // background: linear-gradient(top, rgba(0, 0, 255, 0), rgba(32, 122, 122, 0.3));
// }
// .content::before {
//   content: " ";
//   display: block;
//   position: absolute;
//   width: 100%;
//   right: -0.5%;
//   height: 3px;
//   bottom: -3px;
//   // background: linear-gradient(
//   //   left,
//   //   rgba(0, 0, 255, 0),
//   //   rgba(169, 241, 241, 0.966)
//   // );
// }
</style>


// WEBPACK FOOTER //
// src/components/webgl/ui/pop/pop2.vue